import React, { Component } from "react";
import {
  Image,
  Container,
  Header,
  Grid,
  Menu,
  List,
  Icon,
} from "semantic-ui-react";
import Title from "../assets/images/title.png";
import Bag from "../assets/images/bag.png";
import Phone from "../assets/images/phone.png";
import Flames from "../assets/images/flames.png";
import Stats1 from "../assets/drive-download-20210121T173126Z-001/stat2.png";
import Stats2 from "../assets/drive-download-20210121T173126Z-001/stat3.png";
import Stats3 from "../assets/drive-download-20210121T173126Z-001/Stat1.png";
import Stats4 from "../assets/drive-download-20210121T173126Z-001/stat4.png";
import Doodle2 from "../assets/drive-download-20210121T173126Z-001/doodle2.png";
import LogoWithSponsors from '../assets/images/logos/ELAN L&T_B.png';
import Boat from "../assets/images/boat.png";
import SectionDivider from "../assets/images/divider-1.png";
import ReactFullpage from "@fullpage/react-fullpage";
import "../assets/styles/home.scss";
import One from "../assets/images/flashback/one.jpg";
import Two from "../assets/images/flashback/two.jpg";
import Three from "../assets/images/flashback/three.jpg";
import Four from "../assets/images/flashback/four.jpg";
import Five from "../assets/images/flashback/five.jpg";
import Six from "../assets/images/flashback/six.jpg";
import Seven from "../assets/images/flashback/seven.jpg";
import Eight from "../assets/images/flashback/eight.jpg";
import ImageGallery from "react-image-gallery";
import LT from '../assets/images/logos/L&T 006 B rev.jpg'
// import Logo from "../assets/images/logos/elan-row.png";
import { withUserContext } from "../components/ModalContext";
import {NavLink, Redirect} from "react-router-dom";
import Date from '../assets/images/Date.png';
import MerchBtn from '../assets/images/merch/template.png';

class Home extends Component {
  constructor() {
    super();
    this.carouselRef = React.createRef();
    // this.fullpageRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onLeave(origin, destination, direction) {
    if (origin.index === 0 && direction === "down") {
      setTimeout(() => {
        window.fullpage_api.moveSectionDown();
      });
    } else if (origin.index === 2 && direction === "up") {
      setTimeout(() => {
        window.fullpage_api.moveSectionUp();
      });
    }
  }

  render() {
      if(this.props.redirect){
          return <Redirect to={'/events'}/>
      }
    return (
      <ReactFullpage
        fullpage_api
        licenseKey={"YOUR_KEY_HERE"}
        fitToSection={false}
        onLeave={this.onLeave.bind(this)}
        // fixedElements={'#navbar'}
        scrollOverflow={false}
        // menu={'#navbar'}
        css3={true}
        ref={this.fullpageRef}
        // afterRender={()=>{
        //     if(this.fullpageRef.current)
        //     this.fullpageRef.current.style.transform = 'translate3d(0,-50px,0)';
        // }}
        render={({ state, fullpageApi }) => {
          return (
            <ReactFullpage.Wrapper>
              <div id={"first-section"} className={"home-1 section"}>
                <div className={"section-container"}>
                    {/*<Image className={'logo'} src={LogoWithSponsors}/>*/}
                    <NavLink to={'/merch'} className={'merch-link'}><img src={MerchBtn}/> </NavLink>
                  <Image className={"title-img"} src={Title} centered={true} />
                  <Image className={'date-title'} src={Date} />
                  <a className={'sponsor-link'} target={'_blank'} href={'https://www.larsentoubro.com/'}>
                      <div className={'sponsor-div'}>
                          <Image src={LT}/>
                          <h2>Title Sponsor</h2>
                      </div>
                  </a>
                  <Image className={"flames"} src={Flames} />
                  <Image className={"bag"} src={Bag} />
                  <Image className={"phone"} src={Phone} />

                  <Image className={"boat-1"} src={Boat} />

                  <Image className={"boat-2"} src={Boat} />

                  <Image className={"boat-3"} src={Boat} />
                </div>
              </div>
              {/*<div className={'divider-1'}></div>*/}
              <div className={"divider section fp-auto-height"}>
                <Image src={SectionDivider} />
              </div>
              <div className="home-2 section">
                <div className={"section-container"}>
                  <div className={"textbox"}>
                    <Header className={"heading"}>OUR THEME</Header>
                    <p>
                      This year Elan and ηvision celebrates childhood - the most
                      important phase, capable of shaping and moulding lives.
                      While most of us are in our late teens or early twenties,
                      we help you to relax a bit to take a jog down your memory
                      lane. Fables of a Moppet, our theme will help you to
                      rejoice those times when we hid Roald Dahl's books in
                      textbooks, when a popsicle could make us happy and when
                      stress was just a physics term.
                    </p>
                  </div>
                </div>
              </div>
                <div className={'home-3 section'} style={{height:'100vh',backgroundColor:'#9fff68'}}>
                    <div className={'section-container'}>
                        <div className={'textbox'} >
                            <Header className={'AboutUs'}>
                                ABOUT US
                            </Header>
                            <p>
                                Elan and ηVision is the annual techno-cultural festival of IIT Hyderabad and is one of the largest fests  in South India. Elan refers to the cultural part and Nvision cites the technological part of fest. Elan & ηVision is a 3 days extravaganza, hosting competitions and events across various streams and domains. Students hail from various institutes throughout the country and take away bagful memories and experiences. It promises to be a grand event that exhibits the best of cultural performances, technical solutions and advances from the student community.

                            </p>
                        </div>

                        <Grid centered container columns={4} doubling className={'Grid-3'} style={{ width:'80vw', marginRight:'auto', marginLeft:'auto', paddingTop:'10%'}}>
                            <Grid.Row>
                                <Grid.Column style={{height:'115%'}}>
                                    <Image className={'firstImg-3'} src={Stats1}/>
                                    <p className={'firstTxt-3'}> 12th EDITION</p>
                                </Grid.Column>
                                <Grid.Column>
                                    <Image className={'secondImg-3'} src={Stats2}/>
                                    <p className={'secondTxt-3'}> 50+ EVENTS</p>
                                </Grid.Column>
                                <Grid.Column>
                                    <Image className={'thirdImg-3'} src={Stats3}/>
                                    <p className={'thirdTxt-3'}>10k+ FOOTFALL</p>
                                </Grid.Column>
                                <Grid.Column>
                                    <Image className={'fourthImg-3'} src={Stats4}/>
                                    <p className={'fourthTxt-3'}>150+ COLLEGES</p>
                                </Grid.Column>
                            </Grid.Row>
                            {/*<Grid.Row style={{marginTop: '-2%'}}>
                                        <Grid.Column>
                                            <Header style={{textAlign:'center', color:'#8719ff',fontSize:'2em',fontFamily: '\'Paytone One\', sans-serif'}}>
                                                12th EDITION
                                            </Header>
                                        </Grid.Column >
                                        <Grid.Column>
                                            <Header style={{textAlign:'center', color:'#8719ff',fontSize:'2em',fontFamily: '\'Paytone One\', sans-serif'}}>
                                                50+ EVENTS
                                            </Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header style={{textAlign:'center', color:'#8719ff',fontSize:'2em',fontFamily: '\'Paytone One\', sans-serif'}}>
                                                10k+ FOOTFALL
                                            </Header>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Header style={{textAlign:'center', color:'#8719ff',fontSize:'2em',fontFamily: '\'Paytone One\', sans-serif'}}>
                                                150+ COLLEGES
                                            </Header>
                                        </Grid.Column>
                                     </Grid.Row>*/}
                        </Grid>
                    </div>
                </div>

              <div className="home-4 section">
                <div className={"section-container"}>
                  <div className={"textbox"}>
                    <Header className={"heading"}>
                      FLASHBACK
                      <br />
                      TELEVISION
                    </Header>
                  </div>
                  <Image className={"doodles2"} src={Doodle2} />
                  <div className={"tv-container"}>
                    <div className={"tv-screen"}>
                      <ImageGallery
                        ref={this.carouselRef}
                        showThumbnails={false}
                        showBullets={false}
                        useTranslate3D={false}
                        showFullscreenButton={false}
                        showPlayButton={false}
                        showNav={false}
                        autoPlay={true}
                        slideInterval={2000}
                        items={[
                          { original: One, originalClass: "carousel-item" },
                          { original: Two, originalClass: "carousel-item" },
                          { original: Three, originalClass: "carousel-item" },
                          { original: Four, originalClass: "carousel-item" },
                          { original: Five, originalClass: "carousel-item" },
                          { original: Six, originalClass: "carousel-item" },
                          { original: Seven, originalClass: "carousel-item" },
                          { original: Eight, originalClass: "carousel-item" },
                        ]}
                      />
                    </div>

                    <div
                      className={"prev-btn"}
                      onClick={() =>
                        this.carouselRef.current.slideToIndex(
                          this.carouselRef.current.getCurrentIndex() - 1
                        )
                      }
                    />
                    <div
                      className={"next-btn"}
                      onClick={() =>
                        this.carouselRef.current.slideToIndex(
                          this.carouselRef.current.getCurrentIndex() + 1
                        )
                      }
                    />
                  </div>
                </div>
              </div>
              <div className={"section fp-auto-height"}>
                <Menu
                  style={{
                    backgroundColor: "#f08d25",
                    marginTop: "0px",
                    marginBottom: "0px",
                    paddingBottom: "0px",
                  }}
                >
                  <Menu.Item  className={'left-menu'}>
                    <List>
                      <List.Item
                        className={"socialMedia"}
                        style={{ fontFamily: "'Paytone One', sans-serif" }}
                      >
                        SOCIAL MEDIA
                      </List.Item>
                      <List.Item className={"iconList"}>
                        <a href="https://www.facebook.com/elan.iithyderabad">
                          <Icon
                            className={"icon1"}
                            name="facebook square"
                            size="big"
                            style={{ color: "black" }}
                          />
                        </a>
                        <a href="https://www.instagram.com/elan_nvision.iith/">
                          <Icon
                            className={"icon2"}
                            name="instagram"
                            size="big"
                            style={{ color: "black" }}
                          />
                        </a>
                        <a href="https://twitter.com/elan_nvision?lang=en">
                          <Icon
                            className={"icon3"}
                            name="twitter"
                            size="big"
                            style={{ color: "black" }}
                          />
                        </a>
                        <a href="https://www.youtube.com/user/ElanIITHyderabad">
                          <Icon
                            className={"icon3"}
                            name="youtube"
                            size="big"
                            style={{ color: "black" }}
                          />
                        </a>
                      </List.Item>
                    </List>
                  </Menu.Item>
                  <Menu.Menu position="right" style={{ paddingTop: "0.5%" }}>
                    <List>
                      <List.Item

                          as={NavLink}
                          to={'/contact'}
                          className={"footerText text1 footer-link"}
                        position="right"
                        style={{
                          fontFamily: "'Paytone One', sans-serif",
                          position: "absolute",
                          right: "0",
                          paddingRight: "1%",
                            color:'black',
                        }}
                      >
                        CONTACT US
                      </List.Item>
                      <List.Item
                        onClick={() => this.props.setShow(true)}
                        className={"footerText text2"}
                        position="right"
                        style={{
                          fontFamily: "'Paytone One', sans-serif",
                          position: "absolute",
                          right: "0",
                          paddingRight: "1%",
                          cursor: "pointer",
                        }}
                      >
                        REGISTER
                      </List.Item>
                      <List.Item as={'a'}
                                 href={"https://drive.google.com/file/d/12bEcNHHRXseIuGKPDWVm5WEioimzSc5Q/view?usp=sharing"}
                                 target={'_blank'}
                        className={"footerText text3"}
                        position="right"
                        style={{
                          fontFamily: "'Paytone One', sans-serif",
                          position: "absolute",
                          right: "0",
                          paddingRight: "1%",
                            color:'black'
                        }}
                      >
                        FAQ'S
                      </List.Item>
                    </List>
                  </Menu.Menu>
                </Menu>
              </div>
            </ReactFullpage.Wrapper>
          );
        }}
      />
    );
  }
}

export default withUserContext(Home);
